import { render, staticRenderFns } from "./ProductoProveedorFormComponent.vue?vue&type=template&id=d57c6950&"
import script from "./ProductoProveedorFormComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoProveedorFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports